import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { Button, ButtonTypes } from 'fitbeat.react-native-components';
import { translate } from 'react-i18next';
import Theme from '../../theme';
class TrackingMissingScan extends React.PureComponent {
  render() {
    const { t } = this.props;
    return (
      <View style={styles.container}>
        {this.props.missingDataInfo.map((standardStat) => {
          return (
            <View style={styles.textContainer}>
              <Text style={styles.title}>{standardStat.description}</Text>
              <Text style={styles.subtitle}>{standardStat.error}</Text>
            </View>
          )
        })}
        <View style={styles.buttonContainer}>
          <Button
            isLoading={false}
            fontColor={Theme.PRIMARY}
            buttonType={ButtonTypes.OUTLINE}
            title={t('startBodyScan')}
            style={{ borderRadius: 10 }}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: '100%'
  },
  title: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '300',
    letterSpacing: 0,
    lineHeight: 20,
    marginTop: 10,
    marginLeft: 20,
    marginBottom: 15
  },
  textContainer: {
    borderBottomColor: '#979797',
    borderBottomWidth: 1
  },
  subtitle: {
    color: '#B8B8B8',
    fontSize: 14,
    fontWeight: '300',
    letterSpacing: 0,
    lineHeight: 20,
    marginTop: 10,
    marginLeft: 20,
    marginBottom: 30,
  },
  buttonContainer: {
    paddingHorizontal: 15,
    paddingTop: 10,
    width: '100%'
  }
});

export default translate(['workoutHistory'])(TrackingMissingScan);
